import type { ColumnDef } from "@tanstack/react-table"
import { useMemo } from "react"

import { GoodsReceiptPurchaseOrderLineQuantity, GoodsReceiptValueOrMultiple } from "../components"
import type { PurchaseOrderLineWithReceiptContext } from "../types"

import { ProductStatusCell } from "@/components/table"

export const useGoodsReceiptPurchaseOrderColumns = (): ColumnDef<PurchaseOrderLineWithReceiptContext>[] => {
  return useMemo<ColumnDef<PurchaseOrderLineWithReceiptContext>[]>(() => {
    return [
      {
        accessorKey: "orderId",
        header: "PO #",
        cell: ({ row }) => row.original.orderDetail?.orderId,
      },
      {
        accessorKey: "trackingNumber",
        header: "Container/Tracking #",
        cell: ({ row }) => <GoodsReceiptValueOrMultiple values={row.original.containerTrackingNumbers} />,
      },
      {
        accessorKey: "productId",
        header: "Product ID",
        cell: ({ row }) => {
          const product = row.original.product
          return product ? <ProductStatusCell product={product} /> : null
        },
      },
      {
        accessorKey: "supplierDescription",
        header: "Supplier Description",
        cell: ({ row }) => row.original.product?.vendorDescription,
      },
      {
        accessorKey: "akrochemDescription",
        header: "Akrochem Description",
        cell: ({ row }) => row.original.product?.companyProductDescription,
      },
      {
        accessorKey: "quantity",
        header: "Order Quantity",
        cell: ({ row }) => <GoodsReceiptPurchaseOrderLineQuantity purchaseOrderLine={row.original} />,
      },
    ]
  }, [])
}
